import { render, staticRenderFns } from "./CreateDropdown.vue?vue&type=template&id=5871e441"
import script from "./CreateDropdown.vue?vue&type=script&lang=js"
export * from "./CreateDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports